import { HttpClient } from '@angular/common/http';
import {
  Injectable,
  ModuleWithProviders,
  NgModule,
  NgZone,
} from '@angular/core';
import { Idle, IdleExpiry } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

@Injectable({
  providedIn: 'root',
})
export class FakeKeepalive extends Keepalive {
  constructor(http: HttpClient, zone: NgZone) {
    super(http, zone);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FakeIdleExpiry extends IdleExpiry {
  constructor() {
    super();
  }

  last(value?: Date): Date {
    return value ?? new Date();
  }
}

@Injectable({
  providedIn: 'root',
})
export class FakeIdle extends Idle {
  constructor(expiry: IdleExpiry, zone: NgZone) {
    super(expiry, zone);
  }
}

@NgModule({
  imports: [],
  exports: [],
})
export class FakeNgIdleKeepaliveModule {
  static forRoot(): ModuleWithProviders<FakeNgIdleKeepaliveModule> {
    return {
      ngModule: FakeNgIdleKeepaliveModule,
      providers: [FakeIdleExpiry, FakeKeepalive],
    };
  }
}
